import { Component, OnInit, ViewChild } from '@angular/core';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Overlay } from '@angular/cdk/overlay';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { EditFavoritePopUpComponent } from './pop-ups/edit-favorite-pop-up/edit-favorite-pop-up.component';
import { DeleteFavoritePopUpComponent } from './pop-ups/delete-favorite-pop-up/delete-favorite-pop-up.component';
import { FavoritesService } from '../../services/favorites/favorites.service';
import { RoutePlanningService } from '../../services/route-planning/route-planning.service';
import { FavoriteRoute } from '../../interfaces/favorites/favorite-route.interface';
import { StoredFavorites } from '../../interfaces/favorites/stored-favorites.interface';
import { Address } from '../../interfaces/location/address.interface';
import { FavoriteAddresses } from '../../interfaces/favorites/favorite-addresses.interface';
import { eFavoriteType } from '../../enums/favorite/favorite-type.enum';
import { FavoriteAddress } from '../../interfaces/favorites/favorite-address.interface';
import { SlideUpCardComponent } from 'src/app/@shared/components/design/slide-up-card/slide-up-card.component';
import { AddressAutoCompleteComponent } from '../route-planner-form/forms/source-destination-form/address-auto-complete/address-auto-complete.component';
import { Favorite } from '../../interfaces/favorites/favorite.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import {
  DELETE_FAVORITE_BUTTON,
  DIDNT_ADD_FAVORITE_STATIONS,
  DIDNT_ADD_FAVORITE_LINES,
  DIDNT_ADD_FAVORITE_ROUTES,
  EDIT_FAVORITE,
  FAVORITE_ADDRESSES,
  FAVORITE_LINES,
  FAVORITE_ROUTES,
  FAVORITE_STATIONS,
  FAVORITES_MANAGEMENT,
  NEW_FAVORITE,
  SET_HOME_ADDRESS,
  SET_WORK_ADDRESS,
} from '../../constants/multi-language.constants';
import { eTab } from '../../enums/route-planning/tabs/tabs.enums';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import { Params, Router } from '@angular/router';
import { FavoriteStation } from '../../interfaces/favorites/favorite-station.interface';
import { FavoriteLine } from '../../interfaces/favorites/favorite-line.interface';
import { eSearchStationsOptions } from '../../constants/search-stations-options.constants';
import { LocalStorageService } from 'src/app/@shared/services/local-storage/local-storage.service';
import { CookiesService } from 'src/app/@shared/services/cookies/cookies.service';

@Component({
    selector: 'app-manage-favorites',
    templateUrl: './manage-favorites.component.html',
    styleUrls: ['./manage-favorites.component.scss'],
    standalone: false
})
export class ManageFavoritesComponent
  extends CardDesignComponent
  implements OnInit
{
  @ViewChild('card') override card: SlideUpCardComponent;

  storedFavorites: StoredFavorites;

  direction: Direction;
  favoritesManagementText: string;
  favoriteStationsText: string;
  favoriteLinesText: string;
  favoriteRoutesText: string;
  favoriteAddressesText: string;
  newFavoriteText: string;
  setHomeAddressText: string;
  setWorkAddressText: string;
  didntAddFavoriteStationsTextPart1: string;
  didntAddFavoriteStationsTextPart2: string;
  didntAddFavoriteLinesTextPart1: string;
  didntAddFavoriteLinesTextPart2: string;
  didntAddFavoriteRoutesTextPart1: string;
  didntAddFavoriteRoutesTextPart2: string;
  iconName: string;
  /**
   * a11y: accessible names forwarded to the per-favorite pen/trash icon
   * buttons (favorite-line / favorite-route / favorite-station). The buttons
   * only render a glyph and were previously unnamed for SR users — audit
   * required either a label or removal.
   */
  editFavoriteAriaLabel: string = '';
  deleteFavoriteAriaLabel: string = '';

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,

    private readonly favoritesService: FavoritesService,
    private readonly modalService: ModalService,
    private readonly languageService: LanguageService,
    private readonly queryParamsService: QueryParamsService,
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
    private readonly cookiesService: CookiesService
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.storedFavorites = this.favoritesService.favorites;

    this.favoritesService.onFavoritesChange$.subscribe((favorites) => {
      this.storedFavorites = favorites;
    });

    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      if(this.direction) {
        this.closeCard(true);
        return;
      }
      this.direction = language.direction;
      this.favoritesManagementText = FAVORITES_MANAGEMENT[language.language];
      this.favoriteStationsText = FAVORITE_STATIONS[language.language];
      this.favoriteLinesText = FAVORITE_LINES[language.language];
      this.favoriteRoutesText = FAVORITE_ROUTES[language.language];
      this.favoriteAddressesText = FAVORITE_ADDRESSES[language.language];
      this.newFavoriteText = NEW_FAVORITE[language.language];
      this.setHomeAddressText = SET_HOME_ADDRESS[language.language];
      this.setWorkAddressText = SET_WORK_ADDRESS[language.language];
      this.iconName =
        language.direction === 'rtl' ? 'arrow-right' : 'arrow-left';
      const text = DIDNT_ADD_FAVORITE_STATIONS[language.language];
      const words = text.split(' ');
      this.didntAddFavoriteStationsTextPart1 = words.slice(0, 3).join(' ');
      this.didntAddFavoriteStationsTextPart2 = words.slice(3).join(' ');
      const text2 = DIDNT_ADD_FAVORITE_LINES[language.language];
      const words2 = text2.split(' ');
      this.didntAddFavoriteLinesTextPart1 = words2.slice(0, 3).join(' ');
      this.didntAddFavoriteLinesTextPart2 = words2.slice(3).join(' ');
      const text3 = DIDNT_ADD_FAVORITE_ROUTES[language.language];
      const words3 = text3.split(' ');
      this.didntAddFavoriteRoutesTextPart1 = words3.slice(0, 3).join(' ');
      this.didntAddFavoriteRoutesTextPart2 = words3.slice(3).join(' ');
      this.editFavoriteAriaLabel = EDIT_FAVORITE[language.language];
      this.deleteFavoriteAriaLabel = DELETE_FAVORITE_BUTTON[language.language];
    });
  }

  openEditFavoritePopup(favorite?: Favorite) {
    const allowCookies = this.localStorageService.getItem<boolean>(CookiesService.COOKIES_STORAGE_KEY);
    
    if (allowCookies === false || allowCookies === null || allowCookies === undefined) {
      this.modalService.openAllowCookiesModal().subscribe((consent: boolean) => {
        if (consent) {
          this.openEditFavoritePopupInternal(favorite);
        }
      });
    } else {
      this.openEditFavoritePopupInternal(favorite);
    }
  }

  private openEditFavoritePopupInternal(favorite?: Favorite) {
    this.modalService
      .openPopUp(EditFavoritePopUpComponent, {
        data: {
          favorite: favorite,
        },
      })
      .subscribe(
        () => (this.storedFavorites = this.favoritesService.favorites)
      );
  }
  openDeleteFavoritePopup(
    favorite: FavoriteLine | FavoriteRoute | FavoriteStation
  ) {
    this.modalService
      .openPopUp(DeleteFavoritePopUpComponent, {
        data: {
          favorite: favorite,
        },
      })
      .subscribe(
        () => (this.storedFavorites = this.favoritesService.favorites)
      );
  }

  handleHomeClick(address: Address) {
    this.openComponentOverlay(
      this.direction,
      AddressAutoCompleteComponent,
      {
        title: this.setHomeAddressText,
        hideFeed: true,
        address: address,
        isInnerCard: true,
        saveResultToStorage: false,
      },
      this.card.cardElement,
      (selectedAddress: Address) => {
        if (!!selectedAddress) {
          this.favoritesService.updateFavorite({
            ...selectedAddress,
            type: eFavoriteType.HOME_ADDRESS,
          });
        }
      }
    );
  }

  handleWorkAddress(address: Address) {
    this.openComponentOverlay(
      this.direction,
      AddressAutoCompleteComponent,
      {
        title: this.setWorkAddressText,
        hideFeed: true,
        initialAddress: address,
        isInnerCard: true,
        saveResultToStorage: false,
      },
      this.card.cardElement,
      (selectedAddress: Address) => {
        if (!!selectedAddress) {
          this.favoritesService.updateFavorite({
            ...selectedAddress,
            type: eFavoriteType.WORK_ADDRESS,
          });
        }
      }
    );
  }

  pickFavoriteRoute(favoriteRoute: FavoriteRoute) {
    const params = {
      tab: eTab.SOURCE_DESTINATION,
      dll: `${favoriteRoute.formValues.destination.coordinates.lat}_${favoriteRoute.formValues.destination.coordinates.lng}`,
      dest: `${favoriteRoute.formValues.destination.addressDetails.label}`,
      org: `${favoriteRoute.formValues.origin.addressDetails.label}`,
      oll: `${favoriteRoute.formValues.origin.coordinates.lat}_${favoriteRoute.formValues.origin.coordinates.lng}`,
      saveParams: true,
    };
    this.pickFavorite(params, eTab.SOURCE_DESTINATION);
  }

  pickFavoriteStation(favoriteStation: FavoriteStation) {
    const params = {
      tab: eTab.STATIONS,
      searchType: eSearchStationsOptions[eSearchStationsOptions.STATION],
      stop: favoriteStation.stopcode,
      saveParams: true,
    };
    this.pickFavorite(params, eTab.STATIONS);
  }

  pickFavoriteLine(favoriteLine: FavoriteLine) {
    const params = {
      tab: eTab.LINES,
      routeId: favoriteLine.routeId,
      oppositeRouteId: favoriteLine.oppositeDirectionId,
      line: favoriteLine.routeName,
      boardingStation: favoriteLine.stops[0].stopcode,
      dropingStation:
        favoriteLine.stops[favoriteLine.stops.length - 1].stopcode,
      saveParams: true,
    };
    this.pickFavorite(params, eTab.LINES);
  }

  pickFavorite(params: Params, tab: eTab) {
    if (this.queryParamsService.currentParams['tab'] === tab) {
      params['triggerForm'] = true;
    }
    this.queryParamsService.setQueryParams(params);
    this.closeCard();
  }
}
